import React, {useContext} from "react";
import "../../../../ui-styles/list/AttachmentList.css";
import "../../../../ui-styles/sliders/RightFullSlider.css"
import { LangCtx } from "../../../../lib/context";
import UploadFilesListItem from "../../fileUploads/components/slidelistItem";

const PatientUploadsSlide = (props) => {
    const { l } = useContext(LangCtx);
    
    return (
        <div className={props.open ? "rightFullSlider rightSliderIn" : "rightFullSlider"}>
            <div className="rightSliderHdr">
                <div className="hdrRowBlock">
                    <div className="hdrTitleBox">
                        <span>{l.file_uploads}</span>
                    </div>
                    <div className="hdrActionGroup" onClick={props.close}>
                        <div className="hdrActItem close"></div>
                    </div>
                </div>
            </div>
            <div className="rightSliderBdy">
                <div className="atmntContainer">
                    {/* <UploadFilesListItem /> */}
                    {/* <div className="admntTxtCol">
                        <p className="admnTxtPara">{l.advise}: Sugar test and Blood test</p>
                        <h2 className="atmntHdngTxt">{l.attachments}</h2>
                    </div> */}
                    
                    <ul className="atmntGroup">
                        {props.data.map((item, i) => <UploadFilesListItem file={item} key={`${item.key}_${i}`} access={false}/>)}
              </ul>
                </div>
            </div>

        </div>
    )
}
export default PatientUploadsSlide;